var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiLgSurvey = function SvgAiLgSurvey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 61 30"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 8.02,
    height: 17.819,
    x: 35.98,
    y: 1,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 21.5,
    y: 10,
    fill: "#CBFF88",
    rx: 5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 16.063,
    y: 22.125,
    fill: "#CBFF88",
    rx: 3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M19.063 13.902h21V19l-2.75 2.812-3.063 3.313H19.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M41.13 18.25V4.87H22.87v18.26h13.38a.435.435 0 1 1 0 .87H22.436a.435.435 0 0 1-.435-.435V4.435c0-.24.195-.435.435-.435h19.13c.24 0 .435.195.435.435V18.25a.435.435 0 0 1-.87 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "m26.993 12.63 2.881 2.88 7.133-7.131a.435.435 0 1 1 .614.614l-7.44 7.44a.435.435 0 0 1-.614 0l-3.189-3.188a.435.435 0 0 1 .615-.615M41.565 17.816a.435.435 0 0 1 .308.742l-5.314 5.315a.435.435 0 0 1-.743-.308v-5.314c0-.24.195-.435.435-.435zm-4.88 4.7 3.83-3.83h-3.83z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m50.5 6 .99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566z"
  })));
};
export { SvgAiLgSurvey as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-lg-survey-c771ca87e975d7e2da1eb88c8ddeaf1b.svg";